import LoadingView from "@claroty/xdome-design-system/components/LoadingContainer/LoadingView";
import Page from "../Page/Page";

type PageWithLoaderProps = {
    trackingName: string;
    showBreadcrumbs?: boolean;
};
const PageWithLoader = ({ trackingName, showBreadcrumbs }: PageWithLoaderProps) => {
    return (
        <Page showBreadcrumbs={showBreadcrumbs}>
            <LoadingView trackingName={trackingName} isBig />
        </Page>
    );
};

export default PageWithLoader;
